/* global wp */
import FormField from './form-field';
import PasswordInput from './password-input';

const { __ } = wp.i18n;
const { useState } = wp.element;

const PasswordField = (props) => {
	const { onInput, onError } = props;
	const [error, setError] = useState('');

	const handleChange = (value) => {
		onInput(value);

		let errorFlag = false;

		if (value) {
			setError('');
		} else {
			errorFlag = true;
			setError(__('Password is required.', 'wpmudev'));
		}

		onError(errorFlag);
	};

	return (
		<FormField
			{...props}
			onInput={(e) => handleChange(e)}
			formControl={PasswordInput}
			error={error}
		/>
	);
};

export default PasswordField;
